export default "<ion-icon\n  (click)=\"toggleSubscribeState()\"\n  tappable\n  [@subscribe]=\"subscribeState\"\n  name=\"mail-outline\"\n></ion-icon>\n"